import OverlayType from "./OverlayType";
const OverlayRegistry = Object.freeze((() => {
  const registry = [];
  return {
    register: (name, clazz, type = OverlayType.CUSTOM) => {
      let index = registry.findIndex(entry => entry.name === name);
      if (index >= 0) {
        registry.splice(index, 1);
      }
      registry.push({
        name,
        clazz,
        type
      });
    },
    getClass: name => {
      return registry.find(entry => entry.name === name)?.clazz;
    },
    getType: overlay => {
      return registry.find(entry => overlay instanceof entry.clazz)?.type;
    },
    getName: overlay => {
      return registry.find(entry => overlay instanceof entry.clazz)?.name;
    }
  };
})());
export default OverlayRegistry;